export interface CashOnDeliveryAdministration {
    taskID: string;
    customerPaidTotalPrice: number; // Beszedendő összeg (fix)
    amountReceivedFromCustomer: number; // Vásárlótól átvett összeg
    changeDueToCustomer: number; // Kiszámított visszajáró
    changeGivenToCustomer: number; // Ténylegesen átadott visszajáró
}
